import { Component, ComponentRef, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ScreenType } from 'projects/common/model/ScreenType';
import { Messages, MessagesService } from 'projects/common/services/messages.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { ModalComponent, ModalService } from '@shopping-angular-components/modal';
import { AbstractComponent } from '../../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';

declare const window: any;

interface City {
  name: string;
  code?: string;
}

export interface OriginFilter {
  cities: City[];
  selected: City['code'];
}

@Component({
  selector: 'origin-filter',
  template: `
    <tooltip backgroundColor="-white" position='-bottom -right' [classes]="'origin-button'" [openOnClick]="screenType === 'DESKTOP'" [closeOnOutsideClick]="true" flow="landing" product="nymeria-gui">
      <span label class="origin-filter">
        <div id="origin-button" (click)="openFilter()">
          {{messages.fromPlace}}
          <span class="input eva-3-h5 eva-3-input -md -no-border">
            <input type="text" class="-border-bottom origin" [value]="originName" disabled>
          </span>
          <i class="-eva-3-icon-xsm eva-3-icon-edit -eva-3-tc-brand-primary-3"></i>
        </div>
      </span>

      <div class="eva-3-h4" tooltip-title>{{messages.originFilter}}</div>
      <origin-list tooltip-content [cities]="cities" [model]="module.data" [moduleId]="module.id" [moduleIndex]="module.row_number" [uniqueId]="module.unique_id"></origin-list>
    </tooltip>
  `,
  styleUrls: ['./origin-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OriginFilterComponent extends AbstractComponent implements OnInit {
  @Input() override module: Module<OriginFilter>;
  cities: City[];
  override screenType: ScreenType;
  originName: string;
  messages: Messages;
  modal: ComponentRef<ModalComponent>;
  webview: boolean;

  constructor(injector: Injector,
    private messagesService: MessagesService,
    private modalService: ModalService) {
      super(injector);
      const landingModel = this.landingModelService.getLandingModel();
      this.webview = landingModel.webview;
      this.messages = this.messagesService.getMessages(landingModel.language, landingModel.country);
  }

  ngOnInit(): void {
    this.cities = [{ code: undefined, name: this.messages.originFilterSelect }, ...this.module.data.cities];
    this.originName = this.cities
      .filter(city => city.code === this.module.data.selected)
      .map(city => city.name)[0];
  }

  openFilter() {
    if (this.screenType !== ScreenType.DESKTOP) {
      this.modal = this.modalService.showModal({
        id: 'origin-filter',
        contentComponent: OriginListComponent,
        contentModel: {
          model: this.module.data,
          cities: this.cities
        },
        product: 'nymeria',
        flow: 'promos',
        isWebview: this.webview
      });
    }
  }

  getModuleId(): string {
    return 'OriginFilterModule'
  }

}

@Component({
  selector: 'origin-list',
  template: `
    <ul>
      <li class="list" *ngFor="let city of cities" (click)="this.model?.selected !== city.code && select(city)">
        <span class="eva-3-checkbox">
        <label class="item checkbox-label eva-3-h5">
        <input class="checkbox-tag" type="radio" name="origin" value="{{city.code}}"
                [checked]="this.model?.selected === city.code">
        <i class="checkbox-check eva-3-icon-checkmark -eva-3-mr-sm"></i>
          <span>{{city.name}}</span>
        </label>
        </span>
      </li>
    </ul>
  `,
  styleUrls: ['./origin-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OriginListComponent {
  @Input() uniqueId: string | undefined;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() cities: City[];
  @Input() model?: OriginFilter;

  constructor(private upaService: UpaService) {
  }

  select(city: City) {
    const params = new URLSearchParams(window.location.search);
    if (city.code) {
      params.set('origin', city.code);
    } else {
      params.delete('origin');
    }
    const search = params.toString();
    this.track(city, `?${search}`.replace(/\?$/, ''));
    window.location.search = search;
  }

  private track(city: City, search: string) {
      const href = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${search}`;
      this.upaService.trackTopic('landing', this.upaService.resolveData({
        label: city.name,
        uniqueId: this.uniqueId,
        moduleId: this.moduleId,
        moduleIndex: this.moduleIndex,
        target: UpaTarget.FILTER,
        href: href
      }));
  }
}
